import { useState } from "react";
import { useOutlet } from "react-router-dom";

import { NavBar } from "./NavBar";
import { Sidebar } from "./Sidebar";

export const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const outlet = useOutlet();

  return (
    <div className="flex h-full w-full bg-background-primary dark:bg-background-primary-dark">
      <Sidebar show={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="relative h-full w-full xl:flex xl:pl-64 2xl:pl-72">
        <div className="absolute left-1 xl:relative">
          <NavBar setSidebarOpen={setSidebarOpen} />
        </div>

        <main className="flex w-full flex-col px-11 pt-2 text-primary xl:pt-0">
          {outlet}
        </main>
      </div>
    </div>
  );
};
